import { SiteUrls } from '@tableau/shared-urls';
import { IUserNotification, NotificationsCoreMessages } from '@tableau/user-notifications-client-core';

import { UserNotificationActions } from '../redux/UserNotificationActions';
import { IUserNotificationMenuItemProvider, NotificationMenuItem } from './IUserNotificationMenuItemProvider';

export class UserNotificationMenuItemDefaultProvider<T> implements IUserNotificationMenuItemProvider<T> {
  public constructor(protected userNotificationActions: UserNotificationActions) { }

  public getNotificationMenuItems(notification: IUserNotification<T>, siteUrls: SiteUrls = null): Array<NotificationMenuItem> {
    return [
      {
        title: notification.read ? NotificationsCoreMessages.menuMarkAsUnread() : NotificationsCoreMessages.menuMarkAsRead(),
        testId: 'mark-as-unread-' + notification.id,
        closePanel: false,
        onClick: () => { this.userNotificationActions.updateUserNotificationsStatus([notification.id], !notification.read); }
      },
      {
        title: NotificationsCoreMessages.menuRemoveNotification(),
        testId: 'remove-notification-' + notification.id,
        closePanel: false,
        onClick: () => { this.userNotificationActions.deleteUserNotification(notification.id); }
      }];
  }
}
